import { useEffect, useMemo } from "react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { resolveLegacyUrl } from "../lib/legacy";

function LegacyRedirect({ title = "Redirecting to legacy flow", explicitTarget }) {
  const { t } = useTranslation();
  const location = useLocation();

  const target = useMemo(() => {
    if (explicitTarget) {
      return resolveLegacyUrl(explicitTarget);
    }

    return resolveLegacyUrl(location.pathname, {
      search: location.search || "",
      hash: location.hash || ""
    });
  }, [explicitTarget, location]);

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.replace(target);
    }, 450);

    return () => clearTimeout(timer);
  }, [target]);

  return (
    <div className="min-h-screen bg-app-sand text-app-ink flex items-center justify-center px-6">
      <div className="ui-card max-w-lg w-full text-center animate-fade-up">
        <p className="ui-kicker">{t("new-ui.legacy.compatibility-mode", { defaultValue: "Compatibility mode" })}</p>
        <h1 className="ui-title text-xl mt-2">{title}</h1>
        <p className="ui-copy mt-3">
          {t("new-ui.legacy.description", {
            defaultValue:
              "This route is still served by the current DANASign legacy UI while the new experience is being rolled out."
          })}
        </p>
      </div>
    </div>
  );
}

export default LegacyRedirect;
